export default __webpack_public_path__ + "static/media/cern-extrabold-italic.3d49be55.eot";